
import {UserModel} from '../../auth/models/user.model';
import {JobTypeModel} from './jobType.model';
import {BaseModel} from '../../shared/entities/base.model';


export class JobModel extends BaseModel {
    name: string;
    uid: string;
    jobType: JobTypeModel = null;
    county: County = null;
    city: City = null;
    position: string;
    industry: string;
    departments: Array<JobDepartments>;
    competentRequired: Array<JobCompetents>;
    validUntil: Date;
    mandatoryRecommendation: number;
    description: string;
    created_at: Date;
    updated_at: Date;
    createdByUser: UserModel;
    updatedByUser: UserModel;
}

export class JobCompetents extends BaseModel {
    name: string;
}

export class City extends BaseModel {
    id: number;
    name: string;
    uid: string;
}

export class JobDepartments extends BaseModel {
    name: string;
}

export class County extends BaseModel {
    id: number;
    name: string;
    uid: string;
}
